/*
 * @Author: Dom
 * @Date: 2022-05-18 18:15:06
 * @LastEditTime: 2022-05-31 15:16:23
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\personal\component\phone\locales\en-US.ts
 */
export default {
    'page.personal.center.compontent.bindphone.tips' : 'Enter the binding mobile number',
    'page.personal.center.compontent.codenumber.tips' : 'Enter graphic verification code',
    'page.personal.center.compontent.msgnumber.tips' : 'Enter SMS verification code',
    'page.personal.center.compontent.password.tips' : 'Enter login password',
    'page.personal.center.compontent.phone.btnconfirm' : 'Confirm binding',
    'page.personal.center.compontent.phone.btnconfirm.change' : 'Confirm modification',
    'page.personal.center.compontent.phone.required' : 'Mobile number cannot be empty',
    'page.personal.center.compontent.btnctrl' : 'Cancel',
    'page.personal.center.compontent.close' : 'Shut down',
    'page.personal.center.compontent.btnchangetxt':'Change it',
    'page.personal.center.compontent.verificationtxt':'Get verification code',
    'page.personal.center.compontent.verificationtxtrepeat':'Retrieve verification code',
    'page.personal.center.compontent.bindsuccess':'Mobile phone number binding succeeded!',
    'page.personal.center.compontent.countdown.tips':'Resend in seconds',
}
